import useBcDocumentStore from '../store/bcDocument'
import useBcSearchStore from '../store/bcSearch'
import { mapStores } from 'pinia'
import debounce from 'lodash/debounce'

let lastSearch = null 

export default {
  data() {
    return {
      debouncedSearch: null,
    };
  },
  computed: {
    show () {
      return !this.bcDocumentStore.edit || this.$route.matched[0].name !== 'BCDocument'
    },
    showCloseIcon () {
      return this.search && this.search.length
    },
    search: {
      get() {
        return this.bcSearchStore.query
      },
      set(val) {
        this.bcSearchStore.query = val || val == '' ? val : null
      }
    },
    ...mapStores(useBcSearchStore, useBcDocumentStore),
  },
  methods: {
    onEnter() {
      if (this.search != '') {
        this.$router.replace('/search/' + this.search)
      } else if (this.search == '') {
        this.$router.replace('/search/')
      }
    },
    eraseSerach() {
      this.search = ''
    }
  },
  watch: {
    search (val) {
      if (this.debouncedSearch === null) {
        this.debouncedSearch = debounce((search) => {
          if (search === lastSearch) {
            return
          }

          lastSearch = search

          if (this.$route.matched[0].name === 'BCDocument'
            || this.$route.matched[0].name === 'BCSharedDocument'
            || this.$route.matched[0].name === 'BCFile'
            || this.$route.matched[0].name === 'BCTrashFile'
            || this.$route.matched[0].name === 'BCDeletedFile'
            || search === null) {
            
            return
          }

          if (search == '') {
            this.$router.replace('/search/')
            return
          }

          this.$router.replace('/search/' + search)
        }, 300)
      }

      this.debouncedSearch(val)
    }
  }
}